import React from "react";
import { Modal, Button, Typography } from "antd";
import { ExclamationCircleOutlined, FileSearchOutlined } from "@ant-design/icons";
import { useAtom } from "jotai";
import {
	visibleModalConsentimientoDatosAtom,
	documentoConsentimientoAtom,
	documentoSeleccionadoAtom,
} from "pages/onboarding/OnboardingStore";

const { Title, Paragraph, Text } = Typography;

export function ModalConsentimientoDatos() {
	const [visible, setVisible] = useAtom(visibleModalConsentimientoDatosAtom);
	const [documento] = useAtom(documentoConsentimientoAtom);
	const [, setDocumentoSeleccionado] = useAtom(documentoSeleccionadoAtom);

	const onClickRevisar = () => {
		if (!documento) return;
		setDocumentoSeleccionado(documento);
		setVisible(false);
	};

	return (
		<Modal
			open={visible}
			closable={false}
			footer={null}
			centered
			width={460}
			destroyOnClose
		>
			<div style={{ textAlign: "center", padding: "8px 0 20px" }}>
				<ExclamationCircleOutlined
					style={{ fontSize: 48, color: "#faad14", marginBottom: 16 }}
				/>
				<Title level={4} style={{ marginBottom: 8 }}>
					Consentimiento Pendiente
				</Title>
				<Paragraph type="secondary" style={{ marginBottom: 20 }}>
					Tiene un documento pendiente de revisión:
				</Paragraph>
				<div
					style={{
						background: "#fffbe6",
						border: "1px solid #ffe58f",
						borderRadius: 6,
						padding: "10px 16px",
						marginBottom: 20,
					}}
				>
					<Text strong style={{ fontSize: 13 }}>
						{documento?.nombreDocumento}
					</Text>
				</div>
				<Paragraph type="secondary" style={{ marginBottom: 24, fontSize: 13 }}>
					Debe leer el documento completo antes de aceptar o rechazar el
					consentimiento para el uso de sus datos personales e imagen.
				</Paragraph>
				<Button
					type="primary"
					size="large"
					icon={<FileSearchOutlined />}
					onClick={onClickRevisar}
					style={{ width: "100%" }}
				>
					Revisar Documento para Decidir
				</Button>
			</div>
		</Modal>
	);
}
